var map = {
	"./antonyms.mp3": 85149,
	"./choice_reaction.mp3": 95149,
	"./continuous_performance.mp3": 81714,
	"./dual_n_back.mp3": 57993,
	"./face_name_mix.mp3": 25512,
	"./image_identification.mp3": 91572,
	"./listening.mp3": 74847,
	"./mathematics.mp3": 44078,
	"./matrix_logic.mp3": 27612,
	"./memory_recall.mp3": 85907,
	"./number_sequence.mp3": 32561,
	"./numerical_reasoning.mp3": 92403,
	"./pattern_recognition.mp3": 95394,
	"./reading_comprehension.mp3": 77153,
	"./remote_association.mp3": 65542,
	"./shuffled_sentence.mp3": 4039,
	"./simple_reaction.mp3": 71008,
	"./simple_reaction_sound.mp3": 65260,
	"./sound_differentiation.mp3": 80423,
	"./sound_matching.mp3": 34229,
	"./sound_vocabulary.mp3": 99336,
	"./spatial_rotation.mp3": 91293,
	"./speech_fluency.mp3": 98221,
	"./speed_image_recall.mp3": 49013,
	"./spelling.mp3": 43294,
	"./synonyms.mp3": 49158,
	"./text_matching.mp3": 61357,
	"./verbal_memory.mp3": 70094,
	"./visuo_spatial_reasoning.mp3": 3662,
	"./word_comprehension.mp3": 14389,
	"./word_knowledge.mp3": 26177,
	"./word_phonemes.mp3": 23262,
	"./word_reading.mp3": 44593,
	"./word_sound.mp3": 73168,
	"./writing_ability.mp3": 60027
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83424;